<template>
  <div class="box" v-loading="loading">
    <div v-for="item in tableData" :key="item.contractNo" style="page-break-after: always">
      <div class="print-table">
        <table style="width: 100%; border-color: #000" border="1" cellspacing="0" cellpadding="0">
          <tr>
            <th colspan="14">{{ item.workOrderCompanyName }}</th>
          </tr>
          <tr>
            <th colspan="1">派单部门</th>
            <td colspan="5">{{ item.workOrderDepartmentName }}</td>
            <th colspan="1">工单编号</th>
            <td colspan="5">{{ item.workOrderNo }}</td>
            <!-- <th colspan="1">金额单位</th>
            <td colspan="1">（元）</td> -->
          </tr>
          <tr>
            <th colspan="3">工单名称</th>
            <th>工单类型</th>
            <th colspan="3">报修单号</th>
            <th colspan="2">派单人</th>
            <th colspan="3">接单人</th>
          </tr>
          <tr>
            <td colspan="3">{{ item.name }}</td>
            <td>{{ item.workOrderType }}</td>
            <td colspan="3">{{ item.repairNo }}</td>
            <td colspan="2">{{ item.dispatchPersonName }}</td>
            <td colspan="3">{{ item.receivePersonName }}</td>
          </tr>
          <tr>
            <th>维修项目编号</th>
            <th>维修类型</th>
            <th>维修地点</th>
            <th>维修内容</th>
            <th>维修预估费用（元）</th>
            <th>维修方案</th>
            <th>维修实际费用（元）</th>
            <th>完工日期</th>
            <th>验收人</th>
            <th>验收结果</th>
            <th>验收日期</th>
            <th>验收说明</th>
          </tr>
          <tr v-for="(i, index) in item.workOrderLineDetailList" :key="index">
            <td>{{ i.projectNo }}</td>
            <td>{{ i.type }}</td>
            <td>{{ i.location }}</td>
            <td>{{ i.content }}</td>
            <td>{{ i.estimatedCost }}</td>
            <td>{{ i.plan }}</td>
            <td>{{ i.actualCost }}</td>
            <td>{{ i.completeDate ? formatDate(i.completeDate, true) : '' }}</td>
            <td>{{ i.checkPersonName }}</td>
            <td>{{ i.checkResult }}</td>
            <td>{{ i.checkDate ? formatDate(i.checkDate, true) : '' }}</td>
            <td>{{ i.checkDesc }}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatDate } from '@/utils/date';
  export default {
    data() {
      return {
        tableData: [],
        loading: true,
      };
    },
    created() {
      let query = this.$route.query;
      this.printList(query);
    },
    methods: {
      formatDate,
      async printList(query) {
        this.loading = true;
        this.$axios
          .post(`/property/workOrder/print?access_token=${query.access_token}`, {
            id: query.ids,
            access_token: query.access_token,
          })
          .then(({ data }) => {
            console.log(data);
            if (data.code == 0) {
              this.tableData = data.data;
              setTimeout(() => {
                this.print();
              }, 1500);
            }
            this.loading = false;
          });
      },
      print() {
        window.print();
        window.close();
      },
    },
  };
</script>
<style>
  body {
    height: auto;
  }
</style>

<style scoped lang="scss">
  body,
  .box {
    height: auto !important;
    box-sizing: border-box;
    text-align: center;
    margin: 0 auto;
  }

  @media print {
    @page {
      size: auto A4 landscape;
      margin: 3mm auto;
      text-align: center;
    }

    table {
      border-collapse: collapse !important;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    td {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    thead {
      display: table-header-group;
    }

    tfoot {
      display: table-footer-group;
    }

    .print-table {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    html {
      overflow: visible;
    }
  }
</style>
